import styles from './DashboardItem.less';

import classnames from 'classnames';
import React, { Component, PropTypes } from 'react';

export default class DashboardItem extends Component {

  static propTypes = {
    heading: PropTypes.func.isRequired,
    subheading: PropTypes.func.isRequired,
    count: PropTypes.func
  };

  static defaultProps = {
    count: null
  };

  render() {
    const { heading, subheading, count } = this.props;
    const showCount = (count !== null);
    const className = classnames({
      [styles.root]: true,
      [styles.root_hasCount]: showCount
    });

    return (
      <div className={className}>
        <p className={styles.heading}>{ heading() }</p>
        <p className={styles.subheading}>{ subheading() }</p>
        { showCount && <p className={styles.count}>{ count() }</p> }
      </div>
    );
  }

}



/** WEBPACK FOOTER **
 ** ./app/components/HomePage/components/Dashboard/components/SignedInDashboard/components/DashboardItem/DashboardItem.js
 **/